/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { SVGIcons } from "cms/icons/svg-icons";

/**
 * Removes a list row.
 * @param props
 * @returns {Element}
 * @constructor
 */
const RemoveIcon = (props) => {
    
    const {
        onDeleteItem,
        index,
    } = props || {};

    return (
        <div
            className='remove-icon'
            onClick={() => onDeleteItem(index)}
        >
            <SVGIcons.common.Delete />
        </div>
    );
};
export default RemoveIcon;
